import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
//import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface DischargeTmplParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface DischargeTmpl {
  id?:number;
  tmplName:string;
  tmplCommonFlag?:string;
  tmplReportHeader?:string;
  tmplReportFooter?:string;
  tmplDisplayDept?:string;
  tmplDisplayPhy?:string;
  tmplDisplaySettings?:string;
  tmplActiveFlag:string;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  createdIP?:string;
  updatedIP?:string;
  dischargeTmplDet?:any[];
  detlist?:any;
  tempTitle?:any;
  pageTitle?:any;
  footer?:any;
  parameters?: DischargeTmplParameter[];
  links?: any;
  isActive?:string;
  defaultFlag?:string;
  caid?:number
}
export interface DischargeTmplDet {
  id?:number;
  tmplId:number;
  rowId:number;
  rowHeaderName:string;
  rowDefaultValue:string;
  rowSettings:string;
tenantId?:any;
}

export interface BranchWiseAddressDetail {
        id? : number,
        templateId: number,
        templateHeaderConfig:string,
        templateFooterConfig: string,
        logoId: any,
        tenantId: string,
        branchId: string
}

export abstract class DischargeTmplData { 
  abstract list(url: string): Observable<DischargeTmpl[]>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}